import antdData from 'antd/lib/locale-provider/es_ES'
import localeData from 'react-intl/locale-data/es'

const messages = {
  'sec1.header1': 'DESCUBRE LA TRAZABILIDAD',
  'sec1.header2': 'DE TU JOYA TOUS',
  'sec1.text':
    'Hablar de sostenibilidad es hablar de trazabilidad. En TOUS, somos pioneros en presentar la trazabilidad completa de una joya, desde la compañía minera hasta que llega a ti. Con Tracemark, tienes la certeza de que tu joya es 100% ética y sostenible, de principio a fin.',

  'sec2.description': 'Descripción',
  'sec2.button': 'ID DIGITAL',

  'rawMaterials.header': 'Materias primas',
  'rawMaterials.header.text': 'Oro y diamantes de abastecimiento responsable.',

  'rawMaterials.sec1.header1': 'Oro 100% ético',
  'rawMaterials.sec1.header2': 'y reciclado',
  'rawMaterials.sec1.text1':
    'Esta pieza está hecha con oro 100% ético, reciclado y de origen responsable, proveniente de refinerías que sólo trabajan con oro CoC (Cadena de Custodia). La norma de RJC (Responsible Jewellery Council) Chain of Custody garantiza que el oro ha sido extraído de manera sostenible y siguiendo el Código de Prácticas de RJC.',
  'rawMaterials.sec1.text2':
    'El oro utilizado en esta pieza de joyería proviene de fuentes que han sido verificadas como que cumplen con las mejores prácticas ambientales internacionales y estándares sociales reconocidos en todo el mundo.',
  'rawMaterials.sec1.notTraceableMaterial': 'Material sin trazabilidad Tracemark:',

  'rawMaterials.sec2.header1': 'Diamantes',
  'rawMaterials.sec2.header2': 'trazables de',
  'rawMaterials.sec2.header3': 'origen responsable',
  'rawMaterials.sec2.text1.1': 'Los diamantes de esta joya provienen de la compañía minera ',
  'rawMaterials.sec2.text1.2':
    ', miembro certificado de RJC o DeBeers Sightholder, que garantiza el abastecimiento responsable y el cumplimiento de prácticas sostenibles y éticas a lo largo de toda la cadena de suministro.',
  'rawMaterials.sec2.text2': 'El país de origen de los diamantes es ',
  'rawMaterials.sec2.text3':
    'Cada diamante está verificado por su propio Certificado de Proceso Kimberly, que verifica su autenticidad, procedencia y extracción ética.',
  'rawMaterials.sec2.text4.1': 'La',
  'rawMaterials.sec2.text4.2': 'Certificación del Proceso de Kimberley',
  'rawMaterials.sec2.text4.3':
    'impone requisitos extensos a sus miembros para permitirles certificar los envíos de diamantes en bruto como "libres de conflictos" y evitar que los diamantes en conflicto entren en el comercio legítimo.',

  'fabricationProcess.header1': 'Proceso de fabricación:',
  'fabricationProcess.header2': 'EL ARTE DE LA MANUFACTURA',

  'fabricationProcess.text1':
    'La manufactura de una joya empieza inspirándose en una emoción o idea que se convierte en diseño. Expertos joyeros convierten ese esbozo en una joya única a través de un proceso de fabricación que recoge la tradición del oficio e incorpora innovadoras técnicas de producción. Esta pieza está fabricada en Córdoba, en el sur de España. Desde el modelado y la fundición hasta el repasado, el engastado y el pulido, nuestros artesanos cordobeses van dando forma a esta joya con la pasión del oficio y experta dedicación.',
  'fabricationProcess.text2':
    'Toda la documentación e información sobre la trazabilidad de esta joya ha sido verificada por un auditor externo acreditado por RJC.',
  'fabricationProcessTousHav.text3':
    'La manufactura de una joya empieza inspirándose en una emoción o idea que se convierte en diseño. Expertos joyeros convierten ese esbozo en una joya única a través de un proceso de fabricación que recoge la tradición del oficio e incorpora innovadoras técnicas de producción. Esta pieza está fabricada en Mumbai. Desde el modelado y la fundición hasta el repasado, el engastado y el pulido, nuestros artesanos van dando forma a esta joya con la pasión del oficio y experta dedicación.',

  certificates: 'Certificados',
  download: 'DESCARGAR',

  'digitalPass.header': 'Obtenga su Tracemark ID',
  'digitalPass.step1': 'Autentifique su joya',
  'digitalPass.step2': 'Genere su Tracemark ID',

  'digitalPass.uniqueCode':
    'Código alfanumérico único como aparece grabado en su joya y en la etiqueta de la misma',
  'digitalPass.Authenticate': 'Autentificar',

  'digitalPass.personalDetails': 'Detalles personales',
  'digitalPass.email': 'email',
  'digitalPass.firstName': 'Nombre',
  'digitalPass.lastName': 'Apellido',
  'digitalPass.password.text1': 'Establezca una contraseña',
  'digitalPass.password.text2':
    'Establezca una contraseña para acreditar la propiedad de su joya y obtener su Tracemark ID.',
  'digitalPass.password': 'Contraseña',
  'digitalPass.confirmPassword': 'Confirmar contraseña',
  'digitalPass.generateTracemarkIDButton': 'Obtener Tracemark ID',

  'digitalPass.notificationHeader': 'Descargando Tracemark ID',
  'digitalPass.notificationText':
    'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',

  'digitalPass.termsAndCondition1': 'He leído y acepto de forma expresa la',
  'digitalPass.termsAndCondition2':
    'de “TRACEABLE LUXURY SERVICES, S.L.” y las condiciones del tratamiento de mis datos personales.',

  /* ----------- start Main Consumer Page ------------- */

  'Consumer.sec1.header1': 'DESCUBRE EL IMPACTO POSITIVO AUDITADO Y CERTIFICADO DE TU JOYA',
  'Consumer.sec1.header2': 'DE TU JOYA',
  'Consumer.sec1.text':
    'Esta joya es una pieza de arte con una historia única que contar, verificada por un auditor independiente. Es la historia que cuenta su trazabilidad, demostrando que esta joya es una auténtica creación sostenible y ética, desde su origen hasta tus manos.',

  'Consumer.ia.text1':
    'Toda la información y documentación de la trazabilidad de esta joya ha sido verificada por un auditor externo independiente de reputado prestigio de ',
  'Consumer.ia.text2': ', acreditado por ',

  'downloadDigitalID.text':
    'Registra esta joya a tu nombre para proteger con contraseña su panel de trazabilidad y descargarte tu Tracemark ID – lleva tu Tracemark ID contigo allá donde vayas en la billetera o wallet app de tu móvil para compartir la experiencia.',

  'Consumer.rawMaterials.header': 'MATERIAS PRIMAS',

  'rawMaterials.gold.header1': 'ORO 100% ÉTICO, RECICLADO',
  'rawMaterials.gold.header2': 'Y TRAZABLE',
  'rawMaterials.gold.text1':
    'Esta pieza de joyería está hecha con oro 100% ético, reciclado y de abastecimiento responsable, proveniente de refinerías CoC.',
  'rawMaterials.gold.text2':
    'El oro utilizado en esta pieza procede de fuentes verificadas que cumplen con las mejores prácticas ambientales internacionales y estándares sociales reconocidos en todo el mundo.',
  'rawMaterials.gold.notTraceableMaterial': 'Material sin trazabilidad Tracemark:',

  'rawMaterials.diamond.header1': 'DIAMANTES TRAZADOS DE',
  'rawMaterials.diamond.header2': 'ABASTECIMIENTO RESPONSABLE',
  'rawMaterials.diamond.text1.1': 'Los diamantes de esta pieza provienen de la compañía minera',
  'rawMaterials.diamond.text1.2':
    'Los diamantes de esta pieza provienen de la fuente conocida y verificada',
  'rawMaterials.diamond.text1.3':
    ', miembro certificado de RJC o De Beers Sightholder, que asegura el abastecimiento responsable y el cumplimiento de prácticas sostenibles y éticas a lo largo de toda la cadena de suministro.',
  'rawMaterials.diamond.text2': 'El país de origen de los diamantes es ',
  'rawMaterials.diamond.text3':
    'Cada diamante está verificado por su Certificado del Proceso de Kimberly, que garantiza su autenticidad, procedencia, extracción ética y certifica que está libre de conflicto.',

  'manufacture.header1': 'EL ARTE DE LA MANUFACTURA',

  'manufacture.text':
    'Desde el modelado y la fundición hasta el repasado, el engastado y el pulido, maestros artesanos dan forma a las emociones en esta pieza de joyería cuidando cada detalle, llenándola de la pasión del oficio y puliéndola a mano con delicadeza y experta dedicación.',

  'Consumer.certificates': 'CERTIFICADOS',
  'Consumer.download': 'Descargar',

  /* ----------- end Main Consumer Page ------------- */

  /* ----------- Start Delete TracemarkID Popup ------------- */

  'deleteTracemarkID.link': 'Restablecer la propiedad de esta joya y liberar Tracemark ID',
  'deleteTracemarkID.modal.header': 'Restablecido Tracemark ID',

  'deleteTracemarkID.step1.password': 'Introduzca su contraseña',
  'deleteTracemarkID.step1.button': 'Validar',
  'deleteTracemarkID.step1.forgotPasswordLink': 'He olvidado mi contraseña',

  'deleteTracemarkID.step2.resetText':
    'Escriba RESET para restablecer la propiedad de su Tracemark ID en caso de devolución o entrega a un nuevo propietario.',

  'deleteTracemarkID.step3.success':
    'Gracias. La propiedad y el Tracemark ID para esta joya se han restablecido.',

  /* ----------- End Delete TracemarkID Popup ------------- */

  'downloadCertificate.text1':
    'Para descargarte el certificado de Tracemark de esta pieza, por favor introduce la contraseña utilizada para registrar la joya. Esta es la contraseña que habilitaste para obtener tu Tracemark ID.',
  'downloadCertificate.text2':
    'Si no has registrado tu joya, puedes hacerlo directamente desde el panel de trazabilidad, junto al apartado de Tracemark ID.',

  'downloadCertificate.success':
    'En breve recibirás un correo electrónico con el certificado de Tracemark de esta joya adjunto, a la dirección de correo utilizada para registrar su propiedad.',

  'downloadCertificate.title': 'Descargar certificado',

  /* ----------- Start Tous version 2(v2) changes ------------- */

  'rawMaterials.sec2.v2.text1':
    'Los diamantes de esta pieza de joyería provienen de un tallador de diamantes miembro de De Beers Sightholders, garantizando prácticas de abastecimiento responsables y el cumplimiento de prácticas sostenibles a lo largo de la cadena de suministro.',
  'rawMaterials.sec2.v2.text2':
    'Cada diamante está verificado por su propio Certificado de Proceso Kimberly, que verifica su autenticidad, procedencia y extracción ética.',
  'rawMaterials.sec2.v2.text3':
    'La Certificación del Proceso de Kimberley impone requisitos extensos a sus miembros para permitirles certificar los envíos de diamantes en bruto como "libres de conflictos" y evitar que los diamantes en conflicto entren en el comercio legítimo.',
  /* ----------- End Tous version 2(v2) changes ------------- */

  /* ----------- Start Tous Platinum version 2(v2) changes ------------- */

  'tousPlatinumPanel.rawMaterials.sec1.header1': 'PLATINO',
  'tousPlatinumPanel.rawMaterials.sec1.header2': '100% ÉTICO',
  'tousPlatinumPanel.rawMaterials.sec1.text1':
    'Esta joya ha sido elaborada con platino 100% ético y de origen responsable, obtenido de refinerías europeas acreditadas por el Responsible Jewellery Council (RJC). Estas refinerías cumplen con las certificaciones de Código de Prácticas (CoP) y Cadena de Custodia (CoC), garantizando la trazabilidad y sostenibilidad del metal.',
  'tousPlatinumPanel.rawMaterials.sec1.text2':
    'El platino utilizado proviene de fuentes verificadas que cumplen con los más altos estándares ambientales y sociales reconocidos a nivel internacional, asegurando un impacto positivo en todas las etapas de su producción.',

  'tousPlatinumPanel.rawMaterials.sec2.header1': 'DIAMANTES DE',
  'tousPlatinumPanel.rawMaterials.sec2.header2': 'LABORATORIO TRAZABLES Y',
  'tousPlatinumPanel.rawMaterials.sec2.header3': 'CREADOS RESPONSABLEMENTE',
  'tousPlatinumPanel.rawMaterials.sec2.text1':
    'Los diamantes de laboratorio (LGDs) de esta pieza de joyería provienen de productores y talladores de diamantes, miembros verificados del marco de SMETA (Sedex Members Ethical Trade Audit). Esta afiliación garantiza que todas las operaciones, incluyendo las condiciones laborales y las prácticas ambientales, se adhieren a los más altos estándares de conducta empresarial ética y sostenible a lo largo de toda la cadena de suministro.',
  'tousPlatinumPanel.rawMaterials.sec2.text2':
    'Al asociarnos con entidades que cumplen con los requisitos de SMETA, aseguramos que toda nuestra cadena de suministro esté alineada con las mejores prácticas en clave de sostenibilidad y responsabilidad.',
  'tousPlatinumPanel.rawMaterials.sec2.text3':
    'Además, nuestros proveedores cumplen íntegramente con los criterios de Gobernanza Ambiental, Social y Corporativa (ESG), reafirmando así nuestro compromiso con un abastecimiento ético y sostenible.',
  /* ----------- End Tous Platinum version 2(v2) changes ------------- */

  /* ----------- Start Dynamic Panel Digital pass ------------- */
  'dynamicPanelsDigitalPass.header': 'Obtenga su Pasaporte Tracemark',
  'dynamicPanelsDigitalPass.generateTracemarkIDButton': 'Obtenga su Pasaporte Tracemark',

  'dynamicPanelsDigitalPass.uniqueCode':
    'Inserte el código alfanumérico que aparece en su Etiqueta Tracemark',

  'dynamicPanelsDigitalPass.email': 'Email',
  'dynamicPanelsDigitalPass.email2': 'Email',
  'dynamicPanelsDigitalPass.firstName': 'Nombre',
  'dynamicPanelsDigitalPass.lastName': 'Apellido',
  'dynamicPanelsDigitalPass.password': 'Contraseña',

  'dynamicPanelsDigitalPass.notificationHeader': 'Descargando Tracemark ID',
  'dynamicPanelsDigitalPass.notificationText':
    'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',

  'dynamicPanelsDigitalPass.termsAndCondition1': 'He leído y acepto de forma expresa la',
  'dynamicPanelsDigitalPass.termsAndCondition2': ' política de privacidad ',
  'dynamicPanelsDigitalPass.termsAndCondition3':
    'de “TRACEABLE LUXURY SERVICES, S.L.” y las condiciones del tratamiento de mis datos personales.',

  'dynamicPanelsDigitalPass.resetOwnership': 'Restablece la propiedad de su Pasaporte Tracemark',
  'dynamicPanelsDigitalPass.password.text':
    'Por favor, inserte su contraseña para recuperar su Pasaporte Tracemark',
  'dynamicPanelsDigitalPass.forgotPassword': '¿Ha olvidado su contraseña?',

  'dynamicPanelsDigitalPass.step1': 'Autentifique su joya',
  'dynamicPanelsDigitalPass.step2': 'Generar pasaporte Tracemark',
  'dynamicPanelsDigitalPass.Authenticate': 'Autentificar',
  'dynamicPanelsDigitalPass.personalDetails': 'Detalles personales',
  'dynamicPanelsDigitalPass.password.text1': 'Establezca una contraseña',
  'dynamicPanelsDigitalPass.password.text2':
    'Establezca una contraseña para registrar su propiedad de esta pieza de joyería y proteger su pasaporte Tracemark:',
  'dynamicPanelsDigitalPass.confirmPassword': 'Confirmar contraseña',

  'dynamicPanelsDigitalPass.required.uniqueCode': 'Por favor ingrese el código único',
  'dynamicPanelsDigitalPass.required.name': 'Por favor ingrese el nombre',
  'dynamicPanelsDigitalPass.required.lastName': 'Por favor ingresa el apellido',
  'dynamicPanelsDigitalPass.required.email': 'Por favor ingrese el correo electrónico',
  'dynamicPanelsDigitalPass.required.validEmail': 'Por favor ingrese un correo electrónico válido',
  'dynamicPanelsDigitalPass.required.terms': 'Por favor acepte los términos y condiciones.',
  'dynamicPanelsDigitalPass.required.password': 'Por favor ingrese la contraseña',
  'dynamicPanelsDigitalPass.required.confirmPassword': 'Por favor ingrese confirmar contraseña',
  'dynamicPanelsDigitalPass.required.matchPassword':
    'Su nueva contraseña y la contraseña confirmada no coinciden',
  /* ----------- End  Dynamic Panel Digital pass ------------- */
}

export default {
  locale: 'es-ES',
  antdData,
  localeData,
  messages,
}
